import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HrClearanceComponent } from './hr-clearance.component';
import { AuthGuard } from '../auth.guard';

const routes: Routes = [
  {
    path: 'list',
    component: HrClearanceComponent,
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HrClearanceRoutingModule { }
